// extracted by mini-css-extract-plugin
export var statItem = "_eb-1";
export var statsRow = "_eb-0";